<template>
  <div class="h-100">
    <calendar v-on:updateActiveDate="setActiveDate" :events="nutrutionStats" :user="userProfile"></calendar>

    <v-layout v-if="!loading && goals.protein_percentage" style="margin: 8px 0px" row wrap>
      <v-flex xs12>
        <div class="text-xs-center">
          <v-progress-circular
          :size="100"
          color="primary"
          background-color="grey darken-1"
          :value=goals.protein_percentage
          :width=16
        >{{goals.protein_percentage}} %</v-progress-circular>
        <div>
          <span id="carbs" class="key">Carbs % Fat</span><span id="protein" class="key">Protein</span>
        </div>
        <p class="subheading" style="margin-bottom: 16px;">Daily Calorie Taget: <span class="title">{{goals.daily_calories| ifNull}}</span> kCals (<span class="title">{{goals.protein_percentage}}</span> % Protein)</p>
        </div>
        <v-card flat>
          <v-card-title><h4 class="primary--text">Current Day Protein Info</h4></v-card-title>
          <v-divider></v-divider>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>Amount in Grams:</v-list-tile-content>
              <v-list-tile-content v-if="activeStats" class="align-end">{{activeStats.protein | ifNull}}</v-list-tile-content>
              <v-list-tile-content v-else class="align-end">none</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>Total in kCals:</v-list-tile-content>
              <v-list-tile-content v-if="activeStats" class="align-end">{{activeStats.protein | totalKcals}}</v-list-tile-content>
              <v-list-tile-content v-else class="align-end">none</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>% of Daily Calories:</v-list-tile-content>
              <v-list-tile-content v-if="activeStats" class="align-end">{{protein_percentage}} %</v-list-tile-content>
              <v-list-tile-content v-else class="align-end">none</v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="!loading && !goals.protein_percentage" style="margin: 8px 0px" row wrap>
      <v-flex xs12>
        <div class="text-xs-center">
          <!-- <v-progress-circular
          :size="100"
          color="primary"
          background-color="grey darken-1"
          :value=calorie_percentage
          :width=16
        >{{calorie_percentage}} %</v-progress-circular>
        <div>
          <span id="calories" class="key">Today's Calorie %</span>
        </div> -->
        <p class="subheading" style="margin-bottom: 16px;">Daily Calorie Taget: <span class="title">{{goals.daily_calories | ifNull}}</span> kCals</p>
        </div>
        <v-card flat>
          <v-card-title><h4 class="primary--text">Current Day Calorie Info</h4></v-card-title>
          <v-divider></v-divider>
          <v-list dense>

            <v-list-tile>
              <v-list-tile-content>Total in kCals:</v-list-tile-content>
              <v-list-tile-content v-if="activeStats" class="align-end">{{activeStats.calories}}</v-list-tile-content>
              <v-list-tile-content v-else class="align-end">none</v-list-tile-content>
            </v-list-tile>

          </v-list>
        </v-card>
      </v-flex>
      </v-layout>
      <!-- <v-alert
        dismissible
        class="alert"
        color="secondary"
        :value="true"
        type="info"
      >
        No Calorie target set yet.
      </v-alert> -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
import calendar from '@/components/partial/calendar-buttons.vue'
export default {
  components: {
    calendar
  },
  data () {
    return {
      stats: [],
      goals: {},
      loading: false,
      dateContext: ''
    }
  },
  mounted () {
    this.getStats()
    this.getGoals()
  },
  methods: {
    setActiveDate: function (date) {
      this.loading = true
      this.dateContext = moment(date).startOf('day').unix()
      this.loading = false
    },
    getStats: function () {
      var self = this
      db.collection('user_daily_stats').where('user_id', '==', self.currentUser)
        .onSnapshot(function (snapshot) {
          snapshot.docChanges().forEach(function (change) {
            if (change.type) {
              self.stats.push(change.doc.data())
            }
          })
        })
    },
    getGoals: function () {
      var self = this
      db.collection('user_goals').where('user_id', '==', self.currentUser)
        .onSnapshot(function (snapshot) {
          snapshot.docChanges().forEach(function (change) {
            if (change.type) {
              self.goals = change.doc.data()
            }
          })
        })
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    activeStats: function () {
      var self = this
      var filteredStats = self.stats.filter(function (stat) {
        var dateString = moment.unix(self.dateContext)
        return moment.unix(stat.created_at).isSame(dateString, 'day')
      })
      if (filteredStats.length > 0) {
        if (Array.isArray(filteredStats)) {
          return filteredStats[filteredStats.length - 1]
        } else {
          return filteredStats
        }
      } else {
        return null
      }
    },
    nutrutionStats: function () {
      var self = this
      var filteredStats = self.stats.filter(function (stat) {
        return stat.calories || stat.protein
      })
      return filteredStats
    },
    protein_percentage: function () {
      var protein = this.activeStats.protein
      var calories = this.activeStats.calories
      if (protein && calories) {
        var kcals = Math.floor(protein * 4)
        var percentage = Math.round((kcals / calories) * 100)
        return percentage
      } else {
        return 0
      }
    }
  }
}
</script>
<style scoped>
  .stat-card .v-icon {
    margin-right: 8px;
  }
  .stat-card .headline {
    padding-left: 16px;
  }
  .stat-card .right {
    padding-right: 8px;
    line-height: 28px;
  }
  .stat-card:hover {
    box-shadow: 0 0 6px rgba(15, 113, 67, 1);
  }
  .stat-card.active {
    box-shadow: 0 0 6px rgba(15, 113, 67, 1);
  }
  .flex {
    padding: 8px;
    margin-bottom: 16px;
  }
  .flex.border {
    border-right: 2px solid #E0E0E0;
  }
  .key {
    position: relative;
    line-height: 50px;
  }
  .key:first-of-type {
    margin-right: 30px;
  }
  .key::before {
    content: '.';
    font-size: 100px;
    line-height: 0px;
    position: absolute;
    left: -20px;
    top: -24px;
  }
  .key#calories::before {
    color: #0f7143;
  }
  .key#carbs::before {
    color: #E1E1E1;
  }
  .key#protein::before {
    color: green;
  }
  .alert  {
    position: absolute;
    bottom: 0px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/members/nutritionView.vue